module.exports = __webpack_public_path__ + "static/img/card-contact.f497abd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-contact.png
// module id = rwEf
// module chunks = 34